

import { ActionButton, BaseButton, Button, ChoiceGroup, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, Dropdown, DropdownMenuItemType, IChoiceGroupOption, Icon, IDropdownOption, Label, Panel, PanelType, PrimaryButton, Shimmer, Spinner, SpinnerSize, TextField, Toggle, TooltipHost } from 'office-ui-fabric-react';

import { WsDecodeBoardInterface, WsDecodeMetric, WsDecodeSource } from '../../core/src/interfaces';


import { generateDataValueList, getBoardScorePercent, getLabelList, getMetricStatistic, getMetricValueString, getMetricValueStringPercent, getScoreValue, WsDecodeCard, WsMetricStatistic } from './components/Deliver/Pages/decode-data';








const getBoardMetricOptions = (sourceList: WsDecodeSource[], boardList: WsDecodeBoardInterface[], boardId: string): IDropdownOption[] => {
  const options: IDropdownOption[] = [];

  const boardItem = boardList.find((item) => item.id === Number(boardId));



  if (boardItem) {

    if (boardItem.configuration.profiles && Array.isArray(boardItem.configuration.profiles)) {

      const cardList = boardItem.configuration.profiles as WsDecodeCard[];

      if (cardList.length > 0) {

        options.push({ key: 'BOARDS', text: 'Boards', itemType: DropdownMenuItemType.Header });

        cardList.forEach((cardItem) => {

          const b = boardList.find((item) => item.id === Number(cardItem.boardId));

          if (b && b.id) {

            const bscore = getBoardScorePercent(sourceList, boardList, `${b.id}`);

            options.push({
              key:  `${b.id}`,
              text: `${b.name} (${(bscore / 10).toFixed(1)})`
            });
          }
        });
      }
    }
  }



  return options;
};



export {
  getBoardMetricOptions
};
